import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IFileState, filesTypes } from './types';
import * as filesAction from './actions';
import { modifyFiles } from 'src/utils/fileUtils';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IFileState = {
  // { 1: file, 2: file}
  fileProgress: {},
  isUploadDone: false,
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IFileState, payload: UnsafeReturnType<T>): IFileState;
}

const setUploadFile: IActionHandler<typeof filesAction['setUploadFile']> = (state, { payload }) => ({
  ...state,
  fileProgress: {
    ...state.fileProgress,
    ...modifyFiles(state.fileProgress, payload),
  },
});

const resetUploadFile: IActionHandler<typeof filesAction['resetUploadFile']> = state => ({
  ...state,
  fileProgress: {},
});

const setUploadProgress: IActionHandler<typeof filesAction['setUploadProgress']> = (state, { payload }) => ({
  ...state,
  fileProgress: {
    ...state.fileProgress,
    [payload.id]: {
      ...state.fileProgress[payload.id],
      progress: payload.progress,
    },
  },
});

const successUploadFile: IActionHandler<typeof filesAction['successUploadFile']> = (state, { payload }) => ({
  ...state,
  fileProgress: {
    ...state.fileProgress,
    [payload]: {
      ...state.fileProgress[payload],
      status: 1,
      progress: 100,
    },
  },
});

const failureUploadFile: IActionHandler<typeof filesAction['failureUploadFile']> = (state, { payload }) => ({
  ...state,
  fileProgress: {
    ...state.fileProgress,
    [payload.id]: {
      ...state.fileProgress[payload.id],
      status: 0,
      error: payload.error,
      progress: 100,
    },
  },
});

const setUploadDone: IActionHandler<typeof filesAction['setUploadDone']> = (state, { payload }) => ({
  ...state,
  isUploadDone: payload,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [filesTypes.SET_UPLOAD_FILE]: setUploadFile,
  [filesTypes.RESET_UPLOAD_FILE]: resetUploadFile,
  [filesTypes.SET_UPLOAD_PROGRESS]: setUploadProgress,
  [filesTypes.SUCCESS_UPLOAD_FILE]: successUploadFile,
  [filesTypes.FAILURE_UPLOAD_FILE]: failureUploadFile,
  [filesTypes.SET_UPLOAD_FILE_STATUS]: setUploadDone,
};

const filesReducer = createReducer<IFileState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { filesReducer, filesTypes, filesAction };
